import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { getIsEditing, getShowResetPassword, getShowSwitchAccount, User } from '../../auth/login/store';
import { User as UserIcon } from '../../shared/icons';
import { SidebarMenuModal } from '../../shared/modal/SidebarMenuModal';
import { SidebarMenuOption } from '../../shared/sidebar-menu/SidebarMenu';
import styles from '../Home.module.scss';
import { getMyProfileSection, MyProfileSection, setMyProfileSection } from '../store';
import { MyProfileButtons } from './MyProfileButtons';
import { MyProfileGeneral } from './MyProfileGeneral';
import { MyProfileMyPreferences } from './MyProfileMyPreferences';
import { MyProfileNotifications } from './MyProfileNotifications';
import { MyProfileTableFilters } from './MyProfileTableFilters';

interface MyProfileProps {
    isOpen: boolean;
    myProfile: User;
}

export const MyProfile: React.FC<MyProfileProps> = ({ isOpen, myProfile }) => {
    const dispatch = useAppDispatch();
    const profileSection = useAppSelector(getMyProfileSection);
    const showResetPassword = useAppSelector(getShowResetPassword);
    const showSwitchAccount = useAppSelector(getShowSwitchAccount);
    const isEditing = useAppSelector(getIsEditing);

    const testId = 'my-profile';
    const sideMenuDisabled = useMemo(() => showResetPassword || showSwitchAccount || isEditing, [showResetPassword, showSwitchAccount, isEditing]);
    const selectSection = useCallback((sectionId: string) => dispatch(setMyProfileSection(sectionId as MyProfileSection)), [dispatch]);

    const sections: SidebarMenuOption[] = useMemo(() => [
        { id: MyProfileSection.GENERAL, label: MyProfileSection.GENERAL, element: <MyProfileGeneral user={myProfile} /> },
        { id: MyProfileSection.NOTIFICATIONS, label: MyProfileSection.NOTIFICATIONS, element: <MyProfileNotifications /> },
        { id: MyProfileSection.TABLE_FILTERS, label: MyProfileSection.TABLE_FILTERS, element: <MyProfileTableFilters /> },
        { id: MyProfileSection.MY_PREFERENCES, label: MyProfileSection.MY_PREFERENCES, element: <MyProfileMyPreferences /> }
    ], [myProfile]);

    return (
        <SidebarMenuModal
            isOpen={isOpen}
            sections={sections}
            selected={profileSection}
            openSection={selectSection}
            testId={testId}
            menuDisabled={sideMenuDisabled}
            buttonWrapper={<MyProfileButtons />}
            headerLabel='My Profile'
            headerIcon={UserIcon}
            wrapperClassName={styles.modal}
        />
    );
};
